//import { appUtils } from "../../../../utils/app.utils";

// const isValidCardPan = (value) => {
//     let valid = false;
//     if (value && appUtils.luhnCheck(value) && value.length >= 16 && value.length <= 24) {
//         valid = true;
//     }
//     return valid;
// };

export const validateActivityLogSearch = (values) => {
  const errors = {};

  if (!values.startDate) {
    errors.startDate = "Please enter a start date";
  }
  if (!values.endDate) {
    errors.endDate = "Please enter an end date";
  }
  if (!values.activity) {
    errors.activity = "Please enter an activity";
  }
  if (!values.issuerName) {
    errors.issuerName = "Please enter an issuer name";
  }
  if (!values.username) {
    errors.username = "Please enter a username";
  }
  return errors;
};
